  export class CommentDto {
    id: number;
    orderId?: number;
    attachmentUrl?: string = null;
    comment: string;
    status?: string;
    commentTypeId?: number;
    isPrivate?: boolean;
    file?: any;
    createdBy?: string;
    createdById?: number;
}